import axios from '../../../axios'



// 获取列表
export const list = (data) => {
  return axios({
    url: '/workorder/woRepair/list',
    method: 'post',
    data
  })
}

// 根据Id查找抢修工单
export const findById = (data) => {
  return axios({
    url: '/workorder/woRepair/findById',
    method: 'post',
    data
  })
}

// 根据Id删除抢修工单
export const deleteById = (data) => {
  return axios({
    url: '/workorder/woRepair/delete',
    method: 'post',
    data
  })
}

// 根据Id取消抢修工单
export const cancel = (data) => {
  return axios({
    url: '/workorder/woRepair/cancel',
    method: 'post',
    data
  })
}

// 保存信息
export const save = (data) => {
  return axios({
    url: '/workorder/woRepair/save',
    method: 'post',
    data
  })
}

// 工单提交(进行下一步)
export const submit = (data) => {
  return axios({
    url: '/workorder/woRepair/submit',
    method: 'post',
    data
  })
}

// 开始执行工单
export const start = (data) => {
  return axios({
    url: '/workorder/woRepair/start',
    method: 'post',
    data
  })
}

// 获取工单状态下拉选项
export const findSelectList = () => {
  return axios({
    url: '/workorder/woRepair/findSelectList',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/biz/workorder/woRepair.js